import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { SessionUserSchema, ErrorResponseSchema } from './schemas';
const c = initContract();
export const authContract = c.router({
    login: {
        method: 'GET',
        path: '/auth/login',
        responses: {
            302: z.null(),
        },
        summary: 'Redirect to SSO login',
    },
    me: {
        method: 'GET',
        path: '/auth/me',
        responses: {
            200: z.object({
                success: z.literal(true),
                data: SessionUserSchema,
            }),
            401: ErrorResponseSchema,
        },
        summary: 'Get current authenticated user',
    },
    logout: {
        method: 'POST',
        path: '/auth/logout',
        body: z.undefined(),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.object({ message: z.string() }),
            }),
        },
        summary: 'Logout and clear session',
    },
});
//# sourceMappingURL=auth.js.map